import { testimonials } from "@/mocks/doujin";

export default function Brand() {
  return (
    <section
      id="brand"
      className="scroll-mt-20 bg-gradient-to-br from-primary-500 to-primary-700 py-16 md:py-24"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium tracking-wide text-primary-100">品牌口碑</span>
          <h2 className="font-heading mt-2 text-2xl text-background-50 md:text-4xl">
            同人动漫，为热爱而生
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-100/90 md:text-base">
            我们相信每一份同人创作都值得被看见。同人动漫致力于整理优质漫画本、插画集、四格漫、
            条漫、短篇集与画集打包，构建尊重原创、分类清晰的同人作品内容社区。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <img
                  src={t.avatar}
                  alt={`${t.name}用户头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}